import {useState} from 'react'
import {useIntl} from 'react-intl'
import BulkSheetCard from './components/BulkSheetCard'
import BulkImageField from './components/BulkImageField'
import BulkWhatsNewNotice from './components/BulkWhatsNewNotice'
import SubmitButtonRow from './components/SubmitButtonRow'
import {PRODUCTS_BULK_TEMPLATE} from './core/_requests'
import SharedData from '../../common/SharedData'
import {isBarcodeOnlySheet} from './core/validateBulkSheet'

const BulkCard = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = SharedData()
  const [bulkFile, setBulkFile] = useState<any>({
    value: null,
    error: false,
  })
  const [imagesFile, setImagesFile] = useState<any>({
    value: null,
    error: false,
  })

  // Multi-supplier (B3): reject a barcode-only sheet — an add sheet needs the
  // product columns (a barcode-only file is malformed for add).
  const validateAddSheet = async (file: File): Promise<string | null> => {
    if (await isBarcodeOnlySheet(file)) {
      return formatMessage({id: 'BULK.ERROR.SINGLE_BARCODE_ADD'})
    }
    return null
  }

  return (
    <>
      <BulkWhatsNewNotice />

      <div className='apb-grid'>
        {/* Bulk Sheet */}
        <section className='apb-card'>
          <div className='apb-card-head'>
            <h2 className='apb-card-title'>
              {formatMessage({id: 'bulk_sheet'})} <span className='apb-req'>*</span>
            </h2>
            <i className='fas fa-file-lines' aria-hidden='true' />
          </div>
          <BulkSheetCard
            id='sheet'
            hasError={bulkFile.error}
            setField={setBulkFile}
            templateUrl={PRODUCTS_BULK_TEMPLATE}
            isDownloadable={false}
            token={currentUser?.token}
            user={currentUser}
            validator={validateAddSheet}
          />
        </section>

        {/* Images */}
        <section className='apb-card'>
          <div className='apb-card-head'>
            <h2 className='apb-card-title'>{formatMessage({id: 'images'})}</h2>
            <i className='fas fa-image' aria-hidden='true' />
          </div>
          <BulkImageField hasError={imagesFile.error} id='images' setField={setImagesFile} isRequired={false} />
        </section>
      </div>

      <SubmitButtonRow
        bulkFile={bulkFile}
        setBulkFile={setBulkFile}
        imagesFile={imagesFile}
        setImagesFile={setImagesFile}
      />
    </>
  )
}

export default BulkCard
